<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Search Preferences
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="limit"
              :label="this.localForm.limit"
              :items="selectSearchLimit"
              color="wplblue0"
              prepend-icon="search"
              hint="search limit"
              persistent-hint
              :readonly="this.getUser.basic.rlic !== 'Unlimited'"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="result"
              :label="this.localForm.result"
              :items="selectResult"
              color="wplblue0"
              prepend-icon="reorder"
              hint="register results"
              persistent-hint
              :readonly="this.getUser.basic.rlic !== 'Unlimited'"
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="profile"
              :label="this.localForm.profile"
              :items="selectSearchPrivacy"
              color="wplblue0"
              prepend-icon="person_search"
              hint="profile search"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="privacy"
              :label="this.localForm.privacy"
              :items="selectSearchPrivacy"
              color="wplblue0"
              prepend-icon="manage_search"
              hint="search privacy"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="sortby"
              :label="this.localForm.sortby"
              :items="selectSortBy"
              color="wplblue0"
              prepend-icon="sort"
              hint="sort by"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="sorthow"
              :label="this.localForm.sorthow"
              :items="selectSortHow"
              color="wplblue0"
              prepend-icon="swap_vert"
              hint="sort how"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Page Favourites
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="pageSignin"
              :label="this.localForm.pageSignin"
              :items="selectPageSignin"
              color="wplblue0"
              prepend-icon="login"
              hint="sign in page"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <!-- <div class="ml-2"> -->
            <v-select
              :change="updateFormPref()"
              v-model="pageHome"
              :label="this.localForm.pageHome"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="home"
              hint="home page"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="pageDetail"
              :label="this.localForm.pageDetail"
              :items="selectPageDetail"
              color="wplblue0"
              prepend-icon="description"
              hint="detail"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="pageRegister"
              :label="this.localForm.pageRegister"
              :items="selectPageRegister"
              color="wplblue0"
              prepend-icon="list"
              hint="register"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Settings and Formats
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="auth"
              :label="this.localForm.auth"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="lock"
              hint="security"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="autologoff"
              :label="this.localForm.autologoff"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="watch_later"
              hint="auto log off"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="language"
              :label="this.localForm.language"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="language"
              hint="language"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="date"
              :label="this.localForm.date"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="today"
              hint="date format"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="this.localForm.theme"
              :label="this.localForm.theme"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="palette"
              hint="theme"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="mode"
              :label="this.localForm.mode"
              :items="selectPageHome"
              color="wplblue0"
              prepend-icon="brightness_medium"
              hint="mode"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Selection Company or Facility
          </div>
          <v-spacer/>
          <div class="ml-4 mt-4"
          v-if="
          this.getUserStats.alockc === true &&
          this.getUserStats.alockf === true">
            <span :class="ui.textSubheadingWarning">
              System Lock
            </span>
          </div>
          <div class="ml-4 mt-4"
          v-if="
          this.getUserStats.alockc === true &&
          this.getUserStats.alockf === false">
            <span :class="ui.textSubheadingWarning">
              Company Lock
            </span>
          </div>
          <div class="ml-4 mt-4"
          v-if="
          this.getUserStats.alockc === false &&
          this.getUserStats.alockf === true">
            <span :class="ui.textSubheadingWarning">
              Facility Lock
            </span>
          </div>
          <div class="ml-4 mt-4"
          v-if="
          this.getUserStats.alockc === false &&
          this.getUserStats.alockf === false">
            <span :class="ui.textSubheading">
              Free Access
            </span>
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormPref()"
            v-model="localForm.company"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="account_balance"
            hint="company selection"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6 v-if="this.getUserStats.alockc === true">
            <v-text-field
            :label="this.getUserStats.alockct"
            hint="company lock"
            persistent-hint
            readonly
            >
              <v-icon slot="prepend" :color="ui.colorWarning">
                account_balance
              </v-icon>
            </v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormPref()"
            v-model="localForm.facility"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="place"
            hint="facility selection"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6 v-if="this.getUserStats.alockf === true">
            <v-text-field
            :label="this.getUserStats.alockft"
            hint="facility lock"
            persistent-hint
            readonly
            >
              <v-icon slot="prepend" :color="ui.colorWarning">
                place
              </v-icon>
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="saveSelection"
              :label="this.localForm.saveSelection"
              :items="saveSelectionOptions"
              color="wplblue0"
              :disabled="!lockSelect"
              prepend-icon="toggle_on"
              hint="save selection"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
  </template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import user from "@/data/forms/mixins/user.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line
  mixins: [
    announcements,
    rulesTextfield,
    docRevsModFunctions,
    apptheme,
    user
  ],
  data() {
    return {
      valid: true,
      saveSelectionOptions: ["Save", "Reset"],
      selectSearchLimit: ["100", "1000"],
      selectResult: ["5", "10", "25", "50"],
      selectSearchPrivacy: ["Public", "Private"],
      selectSortBy: ["Date"],
      selectSortHow: ["Ascending"],
      selectPageHome: ["/appdash", "/userdash"],
      selectPageSignin: ["/appdash", "/userdash"],
      selectPageDetail: ["Tab"],
      selectPageRegister: ["Detail"],
      localForm: {
        auth: "",
        mode: "",
        company: "",
        facility: "",
        profile: "",
        limit: "",
        result: "",
        privacy: "",
        pageSignin: "",
        pageHome: "",
        pageDetail: "",
        pageRegister: "",
        date: "",
        theme: "",
        language: "",
        autologoff: "",
        saveSelection: "",
        sorthow: "",
        sortby: ""
      },
      orgForm: {
        auth: "",
        mode: "",
        company: "",
        facility: "",
        profile: "",
        limit: "",
        result: "",
        privacy: "",
        pageHome: "",
        pageSignin: "",
        pageDetail: "",
        pageRegister: "",
        date: "",
        theme: "",
        language: "",
        autologoff: "",
        saveSelection: "",
        sorthow: "",
        sortby: ""
      },
      auth: "",
      mode: "",
      profile: "",
      limit: "",
      result: "",
      privacy: "",
      pageSignin: "",
      pageHome: "",
      pageDetail: "",
      pageRegister: "",
      date: "",
      theme: "",
      language: "",
      autologoff: "",
      selectCompany: "",
      facilityOptions: "",
      saveSelection: "",
      sorthow: "",
      sortby: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    profile() {
      this.localForm.profile = this.profile;
      this.updateFormPref();
    },
    limit() {
      this.localForm.limit = this.limit;
      this.updateFormPref();
    },
    result() {
      this.localForm.result = this.result;
      this.updateFormPref();
    },
    privacy() {
      this.localForm.privacy = this.privacy;
      this.updateFormPref();
    },
    pageSignin() {
      this.localForm.pageSignin = this.pageSignin;
      this.updateFormPref();
    },
    pageHome() {
      this.localForm.pageHome = this.pageHome;
      this.updateFormPref();
    },
    pageDetail() {
      this.localForm.pageDetail = this.pageDetail;
      this.updateFormPref();
    },
    pageRegister() {
      this.localForm.pageRegister = this.pageRegister;
      this.updateFormPref();
    },
    saveSelection() {
      this.localForm.saveSelection = this.saveSelection;
      this.updateFormPref();
    },
    facilityOptions() {
      this.localForm.selectCompany = this.facilityOptions;
      this.updateFormPref();
    },
    sortby() {
      this.localForm.sortby = this.sortby;
      this.updateFormPref();
    },
    sorthow() {
      this.localForm.sorthow = this.sorthow;
      this.updateFormPref();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.auth = this.getDetailPref.settings.auth;
    this.localForm.mode = this.getDetailPref.settings.mode;
    this.localForm.limit = this.getDetailPref.search.limit;
    this.localForm.profile = this.getDetailPref.search.profile;
    this.localForm.result = this.getDetailPref.search.result;
    this.localForm.privacy = this.getDetailPref.search.privacy;
    this.localForm.pageSignin = this.getDetailPref.page.signin;
    this.localForm.pageDetail = this.getDetailPref.page.detail;
    this.localForm.pageRegister = this.getDetailPref.page.register;
    this.localForm.pageHome = this.getDetailPref.page.home;
    this.localForm.date = this.getDetailPref.settings.date;
    this.localForm.autologoff = this.getDetailPref.settings.autologoff;
    this.localForm.language = this.getDetailPref.settings.ln;
    this.localForm.theme = this.getDetailPref.settings.theme;
    this.localForm.sortby = this.getDetailPref.search.sortby;
    this.localForm.sorthow = this.getDetailPref.search.sorthow;

    this.orgForm.auth = this.getDetailPref.settings.auth;
    this.orgForm.mode = this.getDetailPref.settings.mode;
    this.orgForm.profile = this.getDetailPref.search.profile;
    this.orgForm.limit = this.getDetailPref.search.limit;
    this.orgForm.result = this.getDetailPref.search.result;
    this.orgForm.privacy = this.getDetailPref.search.privacy;
    this.orgForm.pageSignin = this.getDetailPref.page.signin;
    this.orgForm.pageHome = this.getDetailPref.page.home;
    this.orgForm.pageRegister = this.getDetailPref.page.register;
    this.orgForm.pageDetail = this.getDetailPref.page.detail;
    this.orgForm.sortby = this.getDetailPref.search.sortby;
    this.orgForm.sorthow = this.getDetailPref.search.sorthow;

    if (this.getUserPref !== null && this.getUserPref !== undefined) {
      this.localForm.company = this.getUserPref.select.cname;
      this.localForm.facility = this.getUserPref.select.fname;
      this.orgForm.company = this.getUserPref.select.cname;
      this.orgForm.facility = this.getUserPref.select.fname;
    } else {
      this.localForm.company = this.getUser.pref.select.cname;
      this.localForm.facility = this.getUser.pref.select.fname;
      this.orgForm.company = this.getUser.pref.select.cname;
      this.orgForm.facility = this.getUser.pref.select.fname;
    }
  },
  computed: {
    ...mapGetters(["getDetailPref", "getUser", "getUserPref", "getUserStats"]),
    lockSelect() {
      let lock = false;
      if (this.getUserPref !== null && this.getUserPref !== undefined) {
        lock = true;
      } else {
        lock = false;
      }
      return lock;
    }
  },
  methods: {
    updateFormPref() {
      let pref = this.getDetailPref;
      // eslint-disable-next-line
      if (this.localForm.limit !== this.orgForm.limit) {
        // after the change re-assign new Local to Org
        this.orgForm.limit = this.localForm.limit;
        // basic
        pref.search.limit = this.localForm.limit;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.privacy !== this.orgForm.privacy) {
        // after the change re-assign new Local to Org
        this.orgForm.privacy = this.localForm.privacy;
        // basic
        pref.search.privacy = this.localForm.privacy;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.pageHome !== this.orgForm.pageHome) {
        // after the change re-assign new Local to Org
        this.orgForm.pageHome = this.localForm.pageHome;
        // basic
        pref.page.home = this.localForm.pageHome;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.pageSignin !== this.orgForm.pageSignin) {
        // after the change re-assign new Local to Org
        this.orgForm.pageSignin = this.localForm.pageSignin;
        // basic
        pref.page.signin = this.localForm.pageSignin;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.result !== this.orgForm.result) {
        // after the change re-assign new Local to Org
        this.orgForm.result = this.localForm.result;
        // basic
        pref.search.result = this.localForm.result;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.saveSelection !== this.orgForm.saveSelection) {
        // SHOW
        // console.log("");
        // console.log(" >>> SAVE USER PREF <<<");
        // console.log(this.localForm.saveSelection);
        // console.log(this.getUser.pref.select);
        // after the change re-assign new Local to Org
        this.orgForm.saveSelection = this.localForm.saveSelection;
        // pref
        if (this.localForm.saveSelection !== "Reset") {
          // MESSAGE
          let msg = null;
          if (
            this.getUserPref.select.cauth !== null &&
            this.getUserPref.select.fauth === null
          ) {
            msg = "New Company was selected ";
            msg = msg + this.getUserPref.select.cname + ".";
          } else {
            msg = "User preferences changed company ";
            msg = msg + this.getUserPref.select.cname + " and ";
            msg = msg + "Facility ";
            msg = msg + this.getUserPref.select.fname;
            msg = msg + " were selected.";
          }
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          if (this.getUserPref !== null && this.getUserPref !== undefined) {
            pref.select = this.getUserPref.select;
          } else {
            pref.select = this.getUser.pref.select;
          }
        } else {
          let msg = "User selection was reset.";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          this.$store.dispatch("changeCompany", null);
          this.$store.dispatch("changeFacility", null);
          pref.select = this.formUserSelect;
        }
        console.log(pref);
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 6); // user new preferences
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.sortby !== this.orgForm.sortby) {
        // after the change re-assign new Local to Org
        this.orgForm.sortby = this.localForm.sortby;
        // basic
        pref.search.sortby = this.localForm.sortby;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.sorthow !== this.orgForm.sorthow) {
        // after the change re-assign new Local to Org
        this.orgForm.sorthow = this.localForm.sorthow;
        // basic
        pref.search.sorthow = this.localForm.sorthow;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.pageDetail !== this.orgForm.pageDetail) {
        // after the change re-assign new Local to Org
        this.orgForm.pageDetail = this.localForm.pageDetail;
        // basic
        pref.page.detail = this.localForm.pageDetail;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.pageRegister !== this.orgForm.pageRegister) {
        // after the change re-assign new Local to Org
        this.orgForm.pageRegister = this.localForm.pageRegister;
        // basic
        pref.page.register = this.localForm.pageRegister;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.41, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
